import Entity from './entity'

const ProcessingNotes = new Entity('processingnotes')

export default ProcessingNotes
